import { Group } from "@mantine/core";
import React from "react";
import QuoRequestEditButton from "./quoRequestEditButton";
import NewTicketButton from "./newTicketButton";
import OrderCancelButton from "./orderCancelButton";
import QuoRequestCompleteButton from "./quoRequestCompleteButton";
import OrderRedoCancelButton from "./orderRedoCancelButton";
import QuoRequestCopyDnButton from "./quoRequestCopyDnButton";
import QuoConfirmButton from "./quoConfirmButton";
import ActionPermissionGate from "./actionPermissionGate";

const QUO_REQ_STATUS_ALLOWED_TO_EDIT = ["DFT"];
const QUO_REQ_STATUS_ALLOW_CONSULTANT_TO_EDIT = ["DFT"];

const QuoRequestActionList = ({ form }) => {
  const { status, code, consultants, _id } = form.values;

  const allowToEdit = () => QUO_REQ_STATUS_ALLOWED_TO_EDIT.includes(status);
  const allowToEditByConsultant = () =>
    QUO_REQ_STATUS_ALLOW_CONSULTANT_TO_EDIT.includes(status);
  const allowToCancel = () => status === "DFT";
  const allowToRedoCancel = () => status === "CAN";
  const allowToComplete = () => status === "DFT";
  const allowToConfirm = () => status === "DONE";
  const allowToCopyDN = () => status === "CONFIRM" || status === "COPIED-DN";

  return (
    <Group>
      {allowToEdit() && (
        <ActionPermissionGate entity="quoRequest" action="editRequest">
          <QuoRequestEditButton mainForm={form} />
        </ActionPermissionGate>
      )}

      {allowToEditByConsultant() && (
        <ActionPermissionGate entity="quoRequest" action="editRequestConsultant">
          <QuoRequestEditButton mainForm={form} />
        </ActionPermissionGate>
      )}

      <ActionPermissionGate entity="quoRequest" action="createTicket">
        <NewTicketButton
          buttonType="fullWidth"
          code={code}
          entityId={_id}
          entity="quoRequest"
          ticketType={"TK-QUOREQ"}
          members={consultants?.map((c) => c._id)}
        />
      </ActionPermissionGate>

      {allowToComplete() && (
        <ActionPermissionGate entity="quoRequest" action="completeRequest">
          <QuoRequestCompleteButton
            mainForm={form}
            title="Complete Request"
            confirmText="Are you sure to complete the request?"
            newStatus="DONE"
          />
        </ActionPermissionGate>
      )}

      {allowToConfirm() && (
        <ActionPermissionGate entity="quoRequest" action="confirmQuotation">
          <QuoConfirmButton mainForm={form} title="Confirm Quotation" />
        </ActionPermissionGate>
      )}

      {allowToCopyDN() && (
        <ActionPermissionGate entity="quoRequest" action="copyToDebitNote">
          <QuoRequestCopyDnButton mainForm={form} title="Copy to Debit Note" />
        </ActionPermissionGate>
      )}

      {allowToCancel() && (
        <ActionPermissionGate entity="quoRequest" action="cancelRequest">
          <OrderCancelButton
            mainForm={form}
            title="Cancel Request"
            confirmText="Are you sure to cancel the request?"
          />
        </ActionPermissionGate>
      )}

      {allowToRedoCancel() && (
        <ActionPermissionGate entity="quoRequest" action="reactiveRequest">
          <OrderRedoCancelButton
            mainForm={form}
            reactiveStatus="DFT"
            title="Reactive Request"
            confirmText="Are you sure to reactive the request?"
          />
        </ActionPermissionGate>
      )}
    </Group>
  );
};

export default QuoRequestActionList;
